var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9862 2.00458H6.01367C4.24992 2.00458 3.86034 2.88291 3.63367 3.95958L2.83325 7.79166H14.1666L13.3662 3.95958C13.1395 2.88291 12.7499 2.00458 10.9862 2.00458Z",
    stroke: "#4E4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5762 14.0392C15.6541 14.8679 14.9883 15.5833 14.1383 15.5833H12.8066C12.0416 15.5833 11.9354 15.2575 11.8008 14.8537L11.6591 14.4287C11.4608 13.8479 11.3333 13.4583 10.3133 13.4583H6.6866C5.6666 13.4583 5.51785 13.8975 5.34077 14.4287L5.1991 14.8537C5.06452 15.2575 4.95827 15.5833 4.19327 15.5833H2.8616C2.0116 15.5833 1.34577 14.8679 1.42369 14.0392L1.82035 9.72541C1.91952 8.66291 2.12494 7.79166 3.98077 7.79166H13.0191C14.8749 7.79166 15.0804 8.66291 15.1795 9.72541L15.5762 14.0392Z",
    stroke: "#4E4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.83333 5.66666H2.125",
    stroke: "#4E4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8751 5.66666H14.1667",
    stroke: "#4E4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.125V3.54167",
    stroke: "#4E4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.4375 3.54166H9.5625",
    stroke: "#4E4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 10.625H6.375",
    stroke: "#4E4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 10.625H12.75",
    stroke: "#4E4D4D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceCar);
export default __webpack_public_path__ + "static/media/serviceCar.521fc8b2.svg";
export { ForwardRef as ReactComponent };